<template>
  <v-container fluid class="pa-0 ma-0">
    <v-radio-group
      hide-details
      v-model="selected"
      :rules="[v => !!v || 'Item is required']"
      :required="field.data.required"
      @change="changed"
      class="pa-2 ma-0"
    >
      <v-row v-for="item in options" :key="item.text" class="mt-2">
        <v-radio :value="item">
          <template v-slot:label>
            <v-layout align-center>
              <div>
                <img
                  v-if="field.data.imageMode == IMAGE_MODES.ICONS && item.imgId"
                  :src="getImgFromBuffer(images[item.imgId])"
                  style="max-width: 50px; max-height: 50px"
                />
              </div>
              <div class="pl-2">
                {{ `${item.text}${item.hasPrice ? ' ($' + item.price + ')' : ''}` }}
              </div>
            </v-layout>
          </template>
        </v-radio>
        <v-text-field
          type="number"
          label="Number of products"
          min="1"
          v-if="field.data.countable && selected == item && item != NO_ITEM"
          v-model="item.count"
          @change="changed"
          @input="changed"
        ></v-text-field>
      </v-row>
    </v-radio-group>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import IMAGE_MODES from '@/constants/imageModes'
import NO_ITEM from '@/constants/noItem'
export default {
  name: 'SelectMultipleTextOptions',
  data() {
    return {
      valid: false,
      selected: [],
      options: [],
      IMAGE_MODES,
      NO_ITEM
    }
  },
  created() {
    if (this.options.length == 0) {
      this.options = [...this.field.data.attrs.options]
      if (this.field.data.countable) {
        this.options.forEach(item => {
          if (!item.count) item.count = 1
        })
      }
      if (!this.field.data.required) this.options.unshift(this.NO_ITEM)
      if (this.field.data.imageMode == IMAGE_MODES.ICONS) {
        this.loadThumbnails(this.field)
      }
    }
    if (this.defaultValue) {
      this.selected = this.defaultValue
    }
  },
  props: {
    field: {
      type: Object,
      required: true
    },
    onChange: {
      type: Function,
      default: () => ''
    },
    defaultValue: {
      type: Object
    }
  },
  computed: {
    images() {
      return this.allImages()
    }
  },
  methods: {
    ...mapActions('images', ['loadThumbnails']),
    ...mapGetters('images', ['allImages']),
    isValid() {
      return this.selected.text
    },
    getImgFromBuffer(buffer) {
      try {
        return 'data:image/jpg;base64, ' + buffer.toString('base64')
      } catch {
        return 'img/no_image.png'
      }
    },
    getFieldRules() {
      const rulesF = []
      if (this.field.data.required) {
        rulesF.push(value => (value && value.length > 0) || 'Required.')
      }
      return rulesF
    },
    getValueObj(item) {
      const obj = { text: item.text }
      if (item.hasPrice) obj.price = item.price
      if (this.field.data.countable) obj.count = item.count
      return obj
    },
    changed() {
      this.onChange({
        id: this.field._id,
        value: this.getValueObj(this.selected),
        rawValues: this.selected,
        ...this.getValidationResults()
      })
    },
    getValidationResults() {
      return this.selected.text || !this.field.data.required
        ? { errMsg: null, valid: true }
        : { errMsg: 'Required', valid: false }
    }
  }
}
</script>

<style lang="scss" scoped></style>
